import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import {asCustomDateString, asCustomDateValue} from '../../../../../helpers/parsing'
import type {DateColumnModel} from '../../../../../models/column-model/custom/date'
import type {TableDataType} from '../../../table-data-type'

export const readDateCellClipboardContent = (row: TableDataType, column: DateColumnModel) => {
  const customColumnValue = row.columns[column.id]
  const customValue = customColumnValue
  const text = asCustomDateString(customValue) || ''
  const raw = asCustomDateValue(customColumnValue) || undefined

  return {text, dataType: MemexColumnDataType.Date, value: raw}
}
